(() => {
  const section = document.querySelector('.product-main');

  /* Tabs */

  const tabs = document.querySelector('[data-kj-tabs]');

  function selectTab(tab, focus) {
    const list = tab.parentElement;
    list.querySelectorAll('[role="tab"]').forEach((other) => {
      const selected = other === tab;
      other.setAttribute('aria-selected', String(selected));
      other.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(other.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    if (focus) tab.focus();
  }

  if (tabs) {
    const list = tabs.querySelector('[role="tablist"]');
    list.addEventListener('click', (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) selectTab(tab, false);
    });
    list.addEventListener('keydown', (event) => {
      const all = Array.from(list.querySelectorAll('[role="tab"]'));
      const index = all.indexOf(document.activeElement);
      if (index < 0) return;
      let next = null;
      if (event.key === 'ArrowRight') next = all[(index + 1) % all.length];
      if (event.key === 'ArrowLeft') next = all[(index - 1 + all.length) % all.length];
      if (event.key === 'Home') next = all[0];
      if (event.key === 'End') next = all[all.length - 1];
      if (!next) return;
      event.preventDefault();
      selectTab(next, true);
    });
  }

  /* Buy box description: clamp it and point to the full text in the tabs */

  const descriptionTab = tabs && tabs.querySelector('[data-kj-tab="description"]');
  const description = section && section.querySelector('.product__information .product__description');
  if (descriptionTab && description && description.textContent.trim().length > 260) {
    description.classList.add('kj-clamp');
    const more = document.createElement('a');
    more.className = 'kj-pdp__more';
    more.href = '#kj-details';
    more.textContent = 'Read more';
    more.addEventListener('click', (event) => {
      event.preventDefault();
      selectTab(descriptionTab, false);
      tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    description.after(more);
  }

  /* Stars link: Klaviyo renders the reviews list inside the apps section */

  const stars = section && section.querySelector('.kj-pdp__stars');
  if (stars) {
    stars.addEventListener('click', (event) => {
      const reviews = document.querySelector(
        '.kl_reviews__list_container, [class*="kl_reviews"], [id*="klaviyo-reviews"]',
      );
      if (!reviews) return;
      event.preventDefault();
      (reviews.closest('.shopify-section') || reviews).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* Collection promo: visual price only. The cart keeps Shopify's automatic discount. */

  document.querySelectorAll('[data-kj-promo]').forEach((promo) => {
    const percent = Number(promo.dataset.percent);
    const selection = promo.closest('.product-main, .shopify-section')?.querySelector('[data-variant-selection]');
    if (!selection || !(percent > 0) || percent >= 100) return;
    const format = window.PXUTheme && PXUTheme.currency && PXUTheme.currency.money_format;
    const nowEl = promo.querySelector('[data-kj-promo-now]');
    const wasEl = promo.querySelector('[data-kj-promo-was]');
    selection.addEventListener('variant-change', (event) => {
      const variant = event.detail && event.detail.variant;
      if (!variant || !window.Shopify || typeof Shopify.formatMoney !== 'function' || !format) return;
      const was = variant.price;
      const now = Math.round((was * (100 - percent)) / 100);
      if (nowEl) nowEl.textContent = Shopify.formatMoney(now, format);
      if (wasEl) wasEl.textContent = Shopify.formatMoney(was, format);
    });
  });

})();
